import type { UserInfo } from '@/types/userInfo';

const SUPPORTED_LANGUAGES = ['ja', 'en'] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const buildLanguageTag = (
    language?: string | null,
    locale?: string | null,
    fallback: string = 'en',
): string => {
    const lang = (language || '').trim();
    const region = (locale || '').trim();
    if (lang && region) {
        return `${lang}-${region}`;
    }
    if (lang) {
        return lang;
    }
    return fallback;
};

export const buildLanguageTagFromUser = (userInfo?: UserInfo | null, fallback: string = 'en'): string => {
    if (!userInfo) return fallback;
    return buildLanguageTag(userInfo.language, userInfo.locale, fallback);
};

export const resolveSupportedLanguage = (
    language?: string | null,
    fallback: SupportedLanguage = 'en',
): SupportedLanguage => {
    const normalized = (language || '').trim().toLowerCase();
    if (SUPPORTED_LANGUAGES.includes(normalized as SupportedLanguage)) {
        return normalized as SupportedLanguage;
    }
    if (normalized.startsWith('ja')) {
        return 'ja';
    }
    if (normalized.startsWith('en')) {
        return 'en';
    }
    return fallback;
};
